import DownloadIcon from '@mui/icons-material/Download';
import { useCallback } from 'react';
import { ChartAction } from '../../../hooks/useChartActions';
import { useExportRowsideEstimatedCountsChart } from '../../../hooks/useExportRowsideEstimatedCountsChart';

export const useBlueberryPerRowsideActions =
  (): ChartAction<BlueberryPerRowsideAction>[] => {
    const { exportCSV } = useExportRowsideEstimatedCountsChart();

    const handleExportClick = useCallback(() => {
      exportCSV();
    }, [exportCSV]);

    const actions: ChartAction<BlueberryPerRowsideAction>[] = [
      {
        actionId: 'EXPORT',
        onClick: handleExportClick,
        Icon: DownloadIcon,
      },
    ];

    return actions;
  };

export type BlueberryPerRowsideAction = 'EXPORT';
